import { API_URL } from "helpers/constant";
import { request } from "./api";

export function getListBanner(params = {}) {
  const queryString = new URLSearchParams(params).toString();
  const url = `${API_URL}/setting/banner${
    queryString ? `?${queryString}` : ""
  }`;

  return request({
    url,
    method: "GET",
  });
}

export function createBanner(body) {
  return request({
    url: `${API_URL}/setting/banner`,
    method: "POST",
    body: JSON.stringify(body),
  });
}

export function updateBanner(body) {
  return request({
    url: `${API_URL}/setting/banner`,
    method: "PUT",
    body: JSON.stringify(body),
  });
}
